module.exports = __webpack_public_path__ + "static/media/Inter-Italic.449b5a38.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-Italic.woff2
// module id = 692
// module chunks = 21